import React from "react";

interface LabelProps {
  children: React.ReactNode;
  color?: "blue" | "green" | "red" | "yellow" | "gray" | "purple" | "indigo" | "orange" | "pink";
  fontSize?: "xs" | "sm" | "base" | "lg" | "xl";
  className?: string;
}

const Label: React.FC<LabelProps> = ({
  children,
  color = "blue",
  fontSize = "xs",
  className = "",
}) => {
  const colorClasses = {
    blue: "bg-blue-100 text-blue-800",
    green: "bg-green-100 text-green-800",
    red: "bg-red-100 text-red-800",
    yellow: "bg-yellow-100 text-yellow-800",
    gray: "bg-gray-100 text-gray-800",
    purple: "bg-purple-100 text-purple-800",
    indigo: "bg-indigo-100 text-indigo-800",
    orange: "bg-orange-100 text-orange-800",
    pink: "bg-pink-100 text-pink-800",
  };

  const fontSizeClasses = {
    xs: "text-xs",
    sm: "text-sm",
    base: "text-base",
    lg: "text-lg",
    xl: "text-xl",
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full font-medium ${colorClasses[color]} ${fontSizeClasses[fontSize]} ${className}`}
    >
      {children}
    </span>
  );
};

export default Label;